module.exports = __webpack_public_path__ + "static/Muli-BoldItalic-b08e7f87210079d91e5cb6ba37788ccb.woff";